/**
 * Triggers a browser file-save dialog for the given Blob.
 *
 * Creates a temporary anchor element pointing at a blob URL, clicks it,
 * and revokes the object URL afterwards.
 *
 * @param blob     The Blob to download.
 * @param filename The filename suggested to the browser save dialog.
 */
export function triggerBlobDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(url);
}
